import React, {useEffect, useState} from "react";
import {getCodeFromLocation} from "./helpers/getCodeFromLocation";
import {getVerifierState} from "./helpers/getVerifierState";
import {fetchToken} from "./helpers/fetchToken";
import {removeCodeFromLocation} from "./helpers/removeCodeFromLocation";
import {removeStateFromStorage} from "./helpers/removeStateFromStorage";
import AuthenticationContext from "./auth-context";
import authorize from "./helpers/authorize";

export interface AuthenticationProviderOptions {
    children?: React.ReactNode;
    client_id?: string;
    provider?: string;
    authorizationEndpoint?: string;
    tokenEndpoint?: string;
    redirect_uri?: string;
    grant_type?:string;
}

const AuthenticationProvider = (opts: AuthenticationProviderOptions): JSX.Element => {

    const {
        children,
        client_id,
        grant_type,
        provider,
        authorizationEndpoint,
        tokenEndpoint,
        redirect_uri,
    
    } = opts;

    const [token, setToken] = useState();
    const storage = sessionStorage;
    const scopes: never[] = [];

    useEffect(() => {
        if (!token) {
            const code = getCodeFromLocation({location: window.location});
            const state = getVerifierState({client_id,storage});
          
            if (code && state ) {
                  fetchToken({
                    client_id,grant_type,tokenEndpoint,code, state, fetch
                })
                    .then(t => {
                        localStorage.setItem('pfJwt', t['access_token']);
                        setToken(t);
                    })
                    .then(() => {
                        removeCodeFromLocation();
                        removeStateFromStorage({client_id, storage});
                    })
                    .catch(e => {
                        console.error(e);
                        alert(`Error fetching auth token: ${e.message}`);
                    })
            }
        }
    }, [token,client_id,grant_type,storage,tokenEndpoint]);

    const checkAuth = () => {
        const code = getCodeFromLocation({location: window.location})
        if (!token && !code) {
            authorize({redirect_uri,grant_type, provider, authorizationEndpoint, client_id, scopes});
        }
    }

    return (
        <AuthenticationContext.Provider value={{token, checkAuth: checkAuth}}>
            {children}
        </AuthenticationContext.Provider>
    );
}

export default AuthenticationProvider;
